import { IconContent } from '@icons';

export const key: IconContent = {
    md: '<path d="M9.879 14.121a3 3 0 1 1-4.243 4.243 3 3 0 0 1 4.243-4.243Zm.331-1.039a4 4 0 1 0 .707.708l5.68-5.68 2.474 2.476.707-.707-2.475-2.475 1.415-1.414 2.474 2.474.708-.707-2.475-2.475-.354-.353-.353-.354-8.508 8.508Z" />',
};
